<template>
  <div class="reservation-pay">
    <van-nav-bar title="修改预约" left-arrow @click-left="$router.back()" placeholder />
    <div class="content">
      <van-cell-group>
        <van-cell title="预约就诊人" :value="details.userMemberName" />
        <van-cell title="预约电话" :value="details.userMemberMobile" />
        <van-cell title="预约医生">
          <div class="doctor select" @click="onDoctorShow">
            <div class="avatar">
              <van-image :src="details.photo" fit="cover" round />
            </div>
            <div class="text">
              <span>{{ details.doctorName }}</span>
              <span>-</span>
              <span>{{ details.clinicalTitle }}</span>
            </div>
          </div>
        </van-cell>
        <van-cell title="问诊方式" :value="askMethodTypes.findValue({ value: details.askType })" />
        <van-cell title="预约挂号费" :value="`￥${details.askServiceFee || 0}`" />
        <van-cell title="预约日期">
          <van-popover v-model="dates.show" trigger="click" :actions="dates.list" @select="onDateChange">
            <template #reference>
              <div class="select">
                <span>{{
      dates.active
        ? formatTime(dates.active).format("YYYY年MM月DD日")
        : "-"
    }}</span>
              </div>
            </template>
          </van-popover>
        </van-cell>
        <van-cell title="预约时段">
          <div class="select" @click="onTimeShow">
            <template v-if="forms.apptStartTime">
              <span>{{ formatTime(forms.apptStartTime).format("HH:mm") }}</span>
              <span>-</span>
              <span>{{ formatTime(forms.apptEndTime).format("HH:mm") }}</span>
            </template>
            <span v-else>请选择</span>
          </div>
        </van-cell>
      </van-cell-group>
    </div>
    <div class="footer">
      <van-button color="#f2f2f2" @click="$router.back()">返回</van-button>
      <van-button type="info" :loading="!submitable" @click="onSubmit">确定</van-button>
    </div>

    <!-- 时段选择 -->
    <ReservationTimes :appt-start-time.sync="times.active.startTime" :appt-end-time.sync="times.active.endTime"
      :appt-self="onTimeAppSelf" :interval="details.firstAsk === 1 ? 30 : 15" ref="ReservationTimesRef"
      @confirm="onTimeConfirm" />

    <!-- 医生选择 -->
    <ReservationDoctors ref="ReservationDoctorsRef" @change="onDoctorChange" />
  </div>
</template>
<script>
import { formatTime } from "@/hooks/function";
import { askMethodTypes } from '@/hooks/useAsk'
import ReservationTimes from "@/components/reservation/times.vue";
import ReservationDoctors from "@/components/reservation/doctors.vue";
import api from "@/utils/request";
export default {
  components: {
    ReservationTimes,
    ReservationDoctors
  },
  data() {
    return {
      askMethodTypes,
      details: {},
      dates: {
        show: false,
        active: "",
        list: [],
      },
      forms: {
        apptStartTime: "",
        apptEndTime: "",
      },
      times: {
        appointed: {
          doctorNo: "",
          startTime: "",
          endTime: "",
        },
        active: {
          startTime: "",
          endTime: "",
        },
      },
      doctors: {
        loading: false,
        appt: {},
      },
      submitable: true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    formatTime,
    async init() {
      try {
        await this.onDataGet();
        await this.onDoctorGet();
      } catch (error) { }
    },
    onDoctorShow() {
      this.$refs.ReservationDoctorsRef && this.$refs.ReservationDoctorsRef.init({
        date: this.dates.active,
        askServiceFee: this.details.askServiceFee,
        askType: this.details.askType,
        doctorNo: this.details.doctorNo
      })
    },
    onDoctorChange(row) {
      this.doctors.appt = JSON.parse(JSON.stringify(row))
      this.details.doctorNo = row.staffNo
      this.details.doctorName = row.staffName
      this.details.photo = row.photo
      this.details.clinicalTitleName = row.clinicalTitleName
      this.forms.apptStartTime = "";
      this.forms.apptEndTime = "";
    },
    async onSubmit() {
      if (!this.submitable) return false;
      if (!this.forms.apptStartTime) {
        this.$toast("请选择预约时段");
        return false;
      }
      this.submitable = false;
      try {
        await api({
          method: "post",
          url: "/user-service/doctormg/askinfo/modifyAppt",
          data: {
            isAppt: 1,
            userNo: this.details.userNo,
            userMemberId: this.details.userMemberId,
            apptStartTime: this.forms.apptStartTime,
            apptEndTime: this.forms.apptEndTime,
            askNo: this.$route.query.askNo,
            doctorNo: this.details.doctorNo,
          },
          headers: {
            "Content-Type": "application/json"
          }
        });
        this.$toast("修改成功");
        setTimeout(() => {
          this.submitable = true;
          this.$router.back();
        }, 1000);
      } catch (error) {
        this.submitable = true;
      }
    },
    onDoctorGet() {
      return new Promise(async (resolve, reject) => {
        this.doctors.loading = true;
        try {
          const { data } = await api({
            method: "get",
            url: "/doctor-service/schedule/getWorkStaffByDate",
            params: {
              date: this.dates.active,
              // 1:医生，2:医助
              type: 1,
              // 1:小程序，2:线下门店 3:企业微信
              source: 3
            },
          });
          this.doctors.appt = data.find(
            (row) => row.staffNo === this.details.doctorNo
          ) || {};
          resolve(true);
        } catch (error) {
          reject(false);
        }
        this.doctors.loading = false;
      });
    },
    onTimeShow() {
      this.times.active.startTime = this.forms.apptStartTime;
      this.times.active.endTime = this.forms.apptEndTime;
      this.$refs.ReservationTimesRef &&
        this.$refs.ReservationTimesRef.onTimeInit(
          this.doctors.appt,
          this.dates.active
        );
    },
    onTimeAppSelf(startTime, endTime) {
      if (this.$refs.ReservationTimesRef) {
        return (
          this.times.appointed.doctorNo === this.details.doctorNo &&
          this.$refs.ReservationTimesRef.onTimeInRange(
            startTime,
            endTime,
            this.times.appointed.startTime,
            this.times.appointed.endTime
          )
        );
      }
      return false;
    },
    onTimeConfirm() {
      this.forms.apptStartTime = this.times.active.startTime;
      this.forms.apptEndTime = this.times.active.endTime;
    },
    async onDateChange(action) {
      if (action.value !== this.dates.active) {
        this.dates.active = action.value;
        this.forms.apptStartTime = "";
        this.forms.apptEndTime = "";
        try {
          await this.onDoctorGet();
        } catch (error) { }
      }
    },
    onDatesCreat(date) {
      const res = [];
      const currentDate = new Date(date);
      for (let i = 0; i < 3; i++) {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();
        const day = currentDate.getDate();
        const recentDate = new Date(year, month, day + i);
        res.push({
          text: formatTime(recentDate).format("YYYY年MM月DD日"),
          value: formatTime(recentDate).format("YYYY-MM-DD"),
        });
      }
      return res;
    },
    async onDataGet() {
      const {
        data: { askInfoDoctor },
      } = await api({
        method: "get",
        url: "/user-service/app/askinfo/getByAskNo",
        params: {
          askNo: this.$route.query.askNo,
        },
      });
      this.details = askInfoDoctor;
      this.dates.active = formatTime(askInfoDoctor.apptStartTime).format(
        "YYYY-MM-DD"
      );
      this.dates.list = this.onDatesCreat(askInfoDoctor.apptStartTime);
      this.forms.apptStartTime = askInfoDoctor.apptStartTime;
      this.forms.apptEndTime = askInfoDoctor.apptEndTime;
      this.times.appointed.doctorNo = this.details.doctorNo || "";
      this.times.appointed.startTime = askInfoDoctor.apptStartTime || "";
      this.times.appointed.endTime = askInfoDoctor.apptEndTime || "";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";

:deep(.van-nav-bar) {

  .van-nav-bar__left,
  .van-icon {
    font-size: 20px;
    color: #333;
  }
}

.reservation-pay {
  height: 100vh;
  @include flex($dir: column);
  background: #fff;
}

.content {
  flex: 1;
  overflow-y: auto;

  :deep(.van-cell__title) {
    flex: none;
    color: #666;
  }

  :deep(.van-cell__value) {
    flex: 1;
    color: #333;
    font-weight: bold;
  }

  .doctor {
    @include flex(center, flex-end);

    .avatar {
      width: 30px;
      height: 30px;

      .van-image {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      margin-left: 10px;
    }
  }

  .coupon {
    @include flex(center, flex-end);

    .price {
      color: #f4722c;
    }

    .van-button {
      font-weight: normal;
      margin-left: 15px;
    }
  }

  .select {
    @include flex(center, flex-end);
    cursor: pointer;

    &::after {
      content: "";
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-top-color: #b2b2b2;
      border-bottom-width: 0;
      margin-left: 5px;
      border-radius: 5px;
    }

    &:active {
      opacity: 0.8;
    }
  }
}

.footer {
  @include flex(center, space-between);
  padding: 30px;

  .van-button {
    border-radius: 50px;

    &:first-child {
      color: #333 !important;
      width: 30%;
    }

    &:not(:first-child) {
      flex: 1;
      margin-left: 30px;
    }
  }
}
</style>
